<div #ngContentRef>
    <ng-content></ng-content>
</div>
<div *ngIf="!ngContentRef.hasChildNodes()">
    <div class="ag-grid-card-wrapper">
        <div *ngFor="let item of gridOptions.data"
             class="ag-grid-card">
            <div class="ag-grid-card-body">
                <div class="ag-grid-card-content">
                    <div class="ag-grid-card-content-form-wrapper"
                         *ngFor="let column of gridOptions.columnDefs"
                         [ngClass]="[column.colClass || 'column-'+column.field]"
                         (click)="gridOptions.cellClick && gridOptions.cellClick($event, item, column, gridOptions)">
                        <span class="ag-grid-card-label" *ngIf="column.label">
                            {{ column.label }}:
                        </span>
                        <span class="ag-grid-card-value"
                              *ngIf="column.cellTemplate">
                            <ng-container *ngTemplateOutlet="column.cellTemplate; context: { value: column.field ? item[column.field] : null, row: item}"></ng-container>
                        </span>
                        <span class="ag-grid-card-value"
                              *ngIf="gridOptions.renderCell && !column.cellTemplate">
                            <span *ngIf="column.enableHtml" [innerHTML]="gridOptions.renderCell(item, column, gridOptions)"></span>
                            <span *ngIf="!column.enableHtml">{{ gridOptions.renderCell(item, column, gridOptions) }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>